import React, { useEffect, useState } from 'react';
import { toInteger } from 'lodash';


import {
  Box,
  Container,
  makeStyles,
  Card,
  CardContent
} from '@material-ui/core';

import { RiArchiveLine } from "react-icons/ri";

import Page from 'src/components/Page';
import agm from '../../services/agm';

import Alerts from '../../utils/alerts';
import Confirmations from '../../utils/confirmations';
import Upload from '../documents/Upload';

import Receipt from './Receipt';
import Results from './Results';
import Toolbar from './Toolbar';
import Create from './Create';
import Launch from './Launch';



const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

var defaultItem = {
  id: null,
  date: null,
  description: null,
  operation: null,
  value: null,
  receipts: null,
  situation: null,
  launcher: null,
  aproved: null,
  aprover: null,
  technician: null,
  typelaunch: null
}

const defaultDependencies = {
  loaded: false,
  launchtypes: [],
  receipts: []
}

const defaultState = {
  loaded: false,
  records: 100,
  pages: 0,
  page: 0,
  count: 0,
  rows: [],
  balance: 0.0,
  credits: 0.0,
  debits: 0.0
}

const defaultUploadState = [];

const defaultStartDateTime = new Date();
const defaultEndDateTime = new Date();

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;


const defaultResultColumns = [
  { name: 'Nome', field: 'item.tecnico.nome', size: -1, sortable: 'nome', exportable: 0, wrap: 0 },
  { name: 'Departamento', field: 'item.tecnico.prestadora.nome', size: -1, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Créditos / Débitos', field: 'formatNumber(item.conta.depositos, "0") + " / " + formatNumber(item.conta.saques, "0")', size: -1, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Aprovados', field: 'formatNumber(item.conta.aprovados, "0")', size: -1, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Abertos', field: 'formatNumber(item.conta.abertos, "0")', size: -1, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Analisar', field: 'formatNumber(item.conta.analisar, "0.00")', size: -1, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Comprovantes', field: '(item.conta.saques > 0) ? formatNumber(item.conta.comprovantes, "0") : ""', size: -1, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Créditos', field: 'formatNumber(item.conta.creditos, "0.00")', size: -1, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Débitos', field: 'formatNumber(item.conta.debitos, "0.00")', size: -1, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Saldo', field: 'formatNumber(parseFloat(item.conta.creditos) + parseFloat(item.conta.debitos), "0.00")', size: -1, sortable: null, exportable: 0, wrap: 0 },
];

const defaultEmptyMessage = "Nenhum Lançamento Foi Encontrado.";

const defaultfullMode = {
  mode: MODE_FULL,
  create: LEVEL_ACCESS_HIDE,
  update: LEVEL_ACCESS_DISABLED,
  delete: LEVEL_ACCESS_HIDE,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  view: LEVEL_ACCESS_ENABLED,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultCompactMode = {
  mode: MODE_COMPACT,
  create: LEVEL_ACCESS_HIDE,
  update: LEVEL_ACCESS_DISABLED,
  delete: LEVEL_ACCESS_HIDE,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  view: LEVEL_ACCESS_ENABLED,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultResultModes = [defaultfullMode, defaultCompactMode];

const defaultVisions = [
  { id: 1, name: 'Todos as Contas', refine: 1, label: 'Nome do Técnico', history: 0 }
];

const defaultFilter = {
  pagina: 0,
  registros: 100,
  inicio: defaultStartDateTime,
  final: defaultEndDateTime,
  palavrachave: '',
  ordenacao: 'asc',
  ordem: '',
  visao: defaultVisions[0],
  tecnico: null
}

const situations = ["Aguardando Recibos", "Aguardando Análise", "Ok"];

const Audit = () => {

  const classes = useStyles();

  const [item, setItem] = useState(defaultItem);
  const [openCreationDialog, setOpenCreationDialog] = useState(false);
  const [openEditionDialog, setOpenEditionDialog] = useState(false);
  const [openDeletionDialog, setOpenDeletionDialog] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [message, setMessage] = useState({});
  const [filter, setFilter] = useState(defaultFilter);
  const [vision, setVision] = useState(defaultVisions[0]);
  const [resultModes, setResultModes] = useState(defaultResultModes);
  const [selectedMode, setSelectedMode] = useState(MODE_FULL);
  const [dependencies, setDependencies] = useState(defaultDependencies);
  const [openUploadDialog, setOpenUploadDialog] = useState(false);
  const [uploadState, setUploadState] = useState(defaultUploadState);
  const [receipt, setReceipt] = useState(null);
  const [openDeletionReceiptDialog, setOpenDeletionReceiptDialog] = useState(false);
  const [openVerifyReceiptDialog, setOpenVerifyReceiptDialog] = useState(false);
  const [openReceiptEditionDialog, setOpenReceiptEditionDialog] = useState(false);
  const [technician, setTechnician] = useState(null);

  const [state, setState] = useState(defaultState);

  const openExportDialog = async (format) => {
    await agm.post('/ocorrencias/export', {
      format: format,
      filtro: filter,
      colunas: defaultResultColumns
    }, {}).then(async (response) => {
      setMessage(response.data);
      setOpenAlert(true);
      const link = window.document.createElement('a');
      var url = process.env.REACT_APP_AGM_ENDPPOINT + '/exports/lancamentos.xlsx';
      link.setAttribute('download', 'lancamentos.xlsx');
      link.href = url;
      window.document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: 'Erro ao gerar o arquivo. ' + error.message });
      setOpenAlert(true);
    });
  }

  const openEdition = async (item) => {
    setItem(item);
    await agm.get('/tecnicos/lancamento/' + item.id, {}, {}).then((response) => {
      if (!response.data.error) {
        setReceipt(response.data.comprovantes.length > 0 ? response.data.comprovantes[0] : null);
        setDependencies({ ...dependencies, receipts: response.data.comprovantes });
        setItem({
          id: response.data.item.id,
          date: response.data.item.data,
          description: response.data.item.descricao,
          operation: response.data.item.operacao,
          value: response.data.item.valor,
          receipts: response.data.comprovantes.length,
          launcher: response.data.item.lancador,
          aproved: response.data.item.aprovacao,
          aprover: response.data.item.aprovador,
          technician: response.data.item.tecnico,
          typelaunch: response.data.item.TP_LANCAMENTO
        });
        setOpenEditionDialog(true);
      } else {
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: 'Erro ao gerar o arquivo. ' + error.message });
      setOpenAlert(true);
    });
  }

  const openCreation = (item) => {
    item.date = new Date();
    item.operation = -1;
    item.technician = filter.tecnico;
    setReceipt(null);
    setDependencies({ ...dependencies, receipts: [] });
    setItem(item);
    setOpenCreationDialog(true);
  }

  const openDeletion = (item) => {
    setItem(item);
    setMessage({
      title: 'Ocorrência',
      message: 'Deseja excluir o lançamento selecionado?',
      warn: 'Esta ação irá alterar o saldo da conta do técnico e pode interferir em lançamentos de despesas de uma ocorrência.'
    });
    setOpenDeletionDialog(true);
  }

  const closeDeletion = () => {
    setOpenDeletionDialog(false);
  };

  const closeEdition = () => {
    refreshItems();
    setOpenEditionDialog(false);
  };

  const closeCreation = () => {
    setOpenCreationDialog(false);
  };

  const closeAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };

  const updateValues = (values) => {
    if (!values.launcher || values.launcher == '') {
      values.launcher = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
    }
    if (localStorage.getItem('profile') == 'ADM' || localStorage.getItem('profile') == 'ENG') {
      var count = 0;
      for (let index = 0; index < dependencies.receipts.length; index++) {
        const element = dependencies.receipts[index];
        if (element.verificado) {
          count++;
        }
      }
      if (count > 0 && count == dependencies.receipts.length) {
        item.aproved = new Date()
        item.aprover = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
      } else {
        item.aproved = null;
        item.aprover = null;
      }
    }

    agm.put('/tecnicos/lancamento/' + values.id, values).then((response) => {
      if (!response.data.error) {
        closeEdition();
        closeCreation();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      closeEdition();
      closeCreation();
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  };

  const createValues = (values) => {
    if (!values.id) {
      values.launcher = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
      values.technician = filter.tecnico;
      agm.post('/tecnicos/lancamento', values).then((response) => {
        if (!response.data.error) {
          refreshItems();
          closeEdition();
          closeCreation();
        }
        setMessage(response.data);
        setOpenAlert(true);
      }).catch((error) => {
        console.error(error);
        closeCreation();
        setMessage({ error: true, fatal: true, message: error.message });
        setOpenAlert(true);
      })
    } else {
      updateValues(values);
    }
  };


  const verifyReceipt = (values) => {
    values.verificado = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
    agm.put('/comprovantes/' + values.id, values).then((response) => {
      if (!response.data.error) {
        setReceipt(values);
        if (localStorage.getItem('profile') == 'ADM' || localStorage.getItem('profile') == 'ENG') {
          var count = 0;
          for (let index = 0; index < dependencies.receipts.length; index++) {
            const element = dependencies.receipts[index];
            if (element.id == values.id) {
              element.verificado = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
            }
            if (element.verificado) {
              count++;
            }
          }
          if (count > 0 && count == dependencies.receipts.length) {
            item.aproved = new Date()
            item.aprover = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
          } else {
            item.aproved = null;
            item.aprover = null;
          }
        }
      } else {
        values.verificado = null
        setReceipt(values);
      }
      closeVerifyReceipt();
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      closeVerifyReceipt();
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })

  }

  const deleteValues = (values) => {
    agm.delete('/tecnicos/lancamento/' + values.id).then((response) => {
      if (!response.data.error) {
        refreshItems();
      }
      closeDeletion();
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      closeDeletion();
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  };

  const refreshItems = () => {
    var ft = filter;
    agm.post('/tecnicos/conta', { filtro: ft }, {
    }).then((response) => {
      if (!response.data.error) {
        setDependencies({ ...dependencies, launchtypes: response.data.tiposLancamento, receipts: [] });
        setState({
          loaded: true,
          pages: toInteger((response.data.count / filter.registros)) + 1,
          page: filter.pagina,
          count: response.data.count,
          rows: response.data.rows,
          balance: response.data.balanco,
          credits: response.data.creditos,
          debits: response.data.debitos
        });
      } else {
        setState(defaultState);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const getTechnician = (id) => {
    if ((localStorage.getItem('userexternalid') != '')) {
      if (localStorage.getItem('profile') == 'ADM' || localStorage.getItem('profile') == 'ENG') {
        setTechnician(id);
        return id;
      } else {
        setTechnician(parseInt(localStorage.getItem('userexternalid')));
        return parseInt(localStorage.getItem('userexternalid'));
      }
    } else {
      setTechnician(id);
      return id;
    }
  }

  const changeSort = (column, order) => {
    var value = {
      ...filter,
      ordem: column.sortable,
      ordenacao: order,
      pagina: 0,
    };
    setFilter(value);
    agm.post('/tecnicos/conta', { filtro: value }, {}).then((response) => {
      if (!response.data.error) {
        setDependencies({ ...dependencies, launchtypes: response.data.tiposLancamento, receipts: [] });
        setState({
          loaded: true,
          pages: toInteger((response.data.count / value.registros)) + 1,
          page: value.pagina,
          count: response.data.count,
          rows: response.data.rows,
          balance: response.data.balance
        });
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const changeFilter = (startDateTime, endDateTime, vision, keyword, page, rows, technician, types) => {
    var value = {
      ...filter,
      pagina: page,
      registros: rows,
      inicio: startDateTime,
      final: endDateTime,
      palavrachave: keyword,
      visao: vision,
      tecnico: getTechnician(technician),
      tipos: types
    };
    setVision(vision);
    setFilter(value);
    agm.post('/tecnicos/conta', { filtro: value }, {}).then((response) => {
      if (!response.data.error) {
        setDependencies({ ...dependencies, launchtypes: response.data.tiposLancamento, receipts: [] });
        setState({
          loaded: true,
          pages: toInteger((response.data.count / value.registros)) + 1,
          page: value.pagina,
          count: response.data.count,
          rows: response.data.rows,
          balance: response.data.balance
        });
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  }

  useEffect(() => {
    if (!state.loaded) {
      refreshItems();
    }
    return
  }, []);

  const openReceiptEdition = (item) => {
    setReceipt(item);
    setOpenReceiptEditionDialog(true);
  }

  const closeReceiptEdition = () => {
    setOpenReceiptEditionDialog(false);
  }


  const closeDeletionReceipt = () => {
    setOpenDeletionReceiptDialog(false);
  }

  const closeVerifyReceipt = () => {
    setOpenVerifyReceiptDialog(false);
  }

  const openVerifyReceipt = (item) => {
    setReceipt(item);
    setMessage({
      title: 'Verificação de Comprovante',
      message: 'Deseja marcar como verificado o arquivo "' + item.nome + '"?',
      warn: 'Esta ação irá registrar sua assinatura como confirmação que o comprovante esta correto'
    });
    setOpenVerifyReceiptDialog(true);
  }

  const openDeletionReceipt = (item) => {
    setReceipt(item);
    setMessage({
      title: 'Comprovante',
      message: 'Deseja excluir o comprovante "' + item.nome + '"?',
      warn: 'Esta ação irá remover o comprovante do local de armazenamento e o arquivo não poderá mais ser recuperado.'
    });
    setOpenDeletionReceiptDialog(true);
  }

  const fileSize = (bytes) => {
    var exp = Math.log(bytes) / Math.log(1024) | 0;
    var result = (bytes / Math.pow(1024, exp)).toFixed(2);
    return result + ' ' + (exp == 0 ? 'bytes' : 'KMGTPEZY'[exp - 1] + 'B');
  }

  const onUpload = (files) => {
    var selectedFiles = files.map(file => ({
      id: file.name,
      name: file.name,
      readableSize: fileSize(file.size),
      uploaded: false,
      preview: URL.createObjectURL(file),
      file,
      progress: 0,
      error: false,
      url: ""
    }));
    setUploadState(selectedFiles);
    selectedFiles.forEach(processUpload);
  }

  const updateFile = ((id, data) => {
    setUploadState((state) =>
      state.map((file) => (file.id === id ? { ...file, ...data } : file))
    );
  });

  const processUpload = ((uploadedFile) => {
    const data = new FormData();
    data.append('lancamento', item.id);
    data.append("file", uploadedFile.file);
    agm.post("/comprovantes/arquivar", data, {
      lancamento: item.id, onUploadProgress: (progressEvent) => {
        let progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        updateFile(uploadedFile.id, { progress });
      },
    })
      .then((response) => {
        if (!response.data.error) {
          updateFile(uploadedFile.id, {
            uploaded: true,
            id: response.data._id,
            url: response.data.url,
          });
        } else {
          console.error(`Houve um problema ao fazer upload do arquivo ${uploadedFile.name} no servidor`);
          updateFile(uploadedFile.id, { error: true });
        }
      })
      .catch((err) => {
        console.error(`Houve um problema ao fazer upload do arquivo ${uploadedFile.name} no servidor.` + err);
        updateFile(uploadedFile.id, { error: true });
      });
  });

  const closeUpload = (values) => {
    agm.get('/tecnicos/lancamento/' + values.id, {}, {}).then((response) => {
      if (!response.data.error) {
        setOpenUploadDialog(false);
        setDependencies({ ...dependencies, receipts: response.data.comprovantes });
        setReceipt((response.data.comprovantes.length > 0) ? response.data.comprovantes[0] : null);
        setItem({
          id: response.data.item.id,
          date: response.data.item.data,
          description: response.data.item.descricao,
          operation: response.data.item.operacao,
          value: response.data.item.valor,
          receipts: response.data.comprovantes.length,
          launcher: response.data.item.lancador,
          aproved: response.data.item.aprovacao,
          aprover: response.data.item.aprovador,
          technician: response.data.item.tecnico,
          typelaunch: response.data.item.TP_LANCAMENTO
        });
      } else {
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: 'Erro ao gerar o arquivo. ' + error.message });
      setOpenAlert(true);
    });
  };

  const openUploadReceipt = (values) => {
    if (values.id == null) {
      values.launcher = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
      values.technician = filter.tecnico;
      agm.post('/tecnicos/lancamento', values).then((response) => {
        if (!response.data.error) {
          item.id = response.data.result.id;
          values.id = response.data.result.id;
          refreshItems();
          setUploadState(defaultUploadState);
          setOpenUploadDialog(true);
        } else {
          setMessage(response.data);
          setOpenAlert(true);
        }
      }).catch((error) => {
        console.error(error);
        closeCreation();
        setMessage({ error: true, fatal: true, message: error.message });
        setOpenAlert(true);
      })
    } else {
      setItem(values)
      setUploadState(defaultUploadState);
      setOpenUploadDialog(true);
    }
  };

  const updateReceiptValues = (values) => {
    agm.put('/comprovantes/' + values.id, values).then((response) => {
      if (!response.data.error) {
        setReceipt(values);
        closeReceiptEdition();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  };

  const deleteReceipt = (values) => {
    agm.delete('/comprovantes/' + values.id).then((response) => {
      if (!response.data.error) {
        agm.get('/tecnicos/lancamento/' + item.id, {}, {}).then((response) => {
          if (!response.data.error) {
            setDependencies({ ...dependencies, receipts: response.data.comprovantes });
            setReceipt((response.data.comprovantes.length > 0) ? response.data.comprovantes[0] : null);
            setItem({
              id: response.data.item.id,
              date: response.data.item.data,
              description: response.data.item.descricao,
              operation: response.data.item.operacao,
              value: response.data.item.valor,
              receipts: response.data.comprovantes.length,
              launcher: response.data.item.lancador,
              aproved: response.data.item.aprovacao,
              aprover: response.data.item.aprovador,
              technician: response.data.item.tecnico,
              typelaunch: response.data.item.TP_LANCAMENTO
            });
          }
        }).catch((error) => {
          console.error(error);
          setMessage({ error: true, info: true, message: 'Erro ao gerar o arquivo. ' + error.message });
        });
      }
      closeDeletionReceipt();
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      closeDeletionReceipt();
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  };

  const changeReceipt = (values) => {
    setReceipt(values);
  }

  return (
    <Page
      className={classes.root}
      title="Lançamento"
    >

      <Container maxWidth={false}>

        <Toolbar
          icon={RiArchiveLine}
          item={defaultItem}
          resultset={state}
          resultModes={resultModes}
          vision={vision}
          visions={defaultVisions}
          selectedMode={selectedMode}
          openCreation={openCreation}
          changeFilter={changeFilter}
          dependencies={dependencies}
        />

        <Upload item={item}
          uploadState={uploadState}
          onUpload={onUpload}
          close={closeUpload}
          open={openUploadDialog}
          destinationTitle={"Enviar Recibo de Pagamento"} />

        <Alerts message={message}
          open={openAlert}
          closeAlert={closeAlert} />

        <Confirmations item={item}
          message={message}
          open={openDeletionDialog}
          close={closeDeletion}
          confirmation={deleteValues} />

        <Confirmations item={receipt}
          message={message}
          open={openVerifyReceiptDialog}
          close={closeVerifyReceipt}
          confirmation={verifyReceipt} />

        <Confirmations item={receipt}
          message={message}
          open={openDeletionReceiptDialog}
          close={closeDeletionReceipt}
          confirmation={deleteReceipt} />

        <Receipt item={receipt}
          closeEdition={closeReceiptEdition}
          updateValues={updateReceiptValues}
          open={openReceiptEditionDialog}
        />

        <Create item={item}
          open={openCreationDialog}
          closeCreation={closeCreation}
          createValues={createValues}
          openUploadReceipt={openUploadReceipt}
          openReceiptEdition={openReceiptEdition}
          selectedMode={selectedMode}
          receipt={receipt}
          changeReceipt={changeReceipt}
          openDeletionReceipt={openDeletionReceipt}
          dependencies={dependencies}
        />

        <Launch item={item}
          open={openEditionDialog}
          closeEdition={closeEdition}
          updateValues={updateValues}
          openUploadReceipt={openUploadReceipt}
          openReceiptEdition={openReceiptEdition}
          selectedMode={selectedMode}
          receipt={receipt}
          changeReceipt={changeReceipt}
          openDeletionReceipt={openDeletionReceipt}
          dependencies={dependencies}
          openVerifyReceipt={openVerifyReceipt}
        />

        <Box mt={3}>
          <Card>
            <CardContent>
              <Results
                resultSet={state}
                resultModes={resultModes}
                icon={RiArchiveLine}
                vision={vision}
                selectedMode={selectedMode}
                openEdition={openEdition}
                openDeletion={openDeletion}
                openExportDialog={openExportDialog}
                changeSort={changeSort}
                dependencies={dependencies}
                situations={situations}
              />
            </CardContent>
          </Card>
        </Box>
      </Container>
    </Page>
  );
};

export default Audit;